import React, { useState, useEffect } from 'react';
import { MessageSquare, Clock, CheckCircle, AlertCircle, Plus, Filter, X } from 'lucide-react';
import TanyaITModal from './TanyaITModal';

const API_URL = process.env.REACT_APP_BACKEND_URL !== undefined && process.env.REACT_APP_BACKEND_URL !== '' ? process.env.REACT_APP_BACKEND_URL : '';

const TanyaITList = () => {
  const [tikets, setTikets] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filterStatus, setFilterStatus] = useState('');
  const [filterKategori, setFilterKategori] = useState('');
  const [selectedTiket, setSelectedTiket] = useState(null);
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    fetchTikets();
  }, [filterStatus, filterKategori]);

  const fetchTikets = async () => {
    setLoading(true);
    try {
      const token = localStorage.getItem('token');
      const queryParams = new URLSearchParams();
      if (filterStatus) queryParams.append('status', filterStatus);
      if (filterKategori) queryParams.append('kategori', filterKategori);

      const response = await fetch(`${API_URL}/api/tiket-it?${queryParams}`, {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });

      if (response.ok) {
        const data = await response.json();
        setTikets(data.tiket || []);
      }
    } catch (err) {
      console.error('Gagal mengambil tiket:', err);
    } finally {
      setLoading(false);
    }
  };

  const getStatusBadge = (status) => {
    const styles = {
      open: 'bg-yellow-100 text-yellow-800 border-yellow-300',
      in_progress: 'bg-blue-100 text-blue-800 border-blue-300',
      resolved: 'bg-green-100 text-green-800 border-green-300',
      closed: 'bg-gray-100 text-gray-800 border-gray-300'
    };
    const labels = {
      open: 'Open',
      in_progress: 'Dalam Proses',
      resolved: 'Selesai',
      closed: 'Closed'
    };

    return (
      <span className={`px-3 py-1 rounded-full text-xs font-semibold border ${styles[status] || styles.open}`}>
        {labels[status] || status}
      </span>
    );
  };

  const getKategoriBadge = (kategori) => {
    const styles = {
      masukan: 'bg-purple-100 text-purple-800',
      keluhan: 'bg-red-100 text-red-800',
      rekomendasi: 'bg-blue-100 text-blue-800',
      bug: 'bg-orange-100 text-orange-800',
      error: 'bg-red-100 text-red-800'
    };

    return (
      <span className={`px-3 py-1 rounded-full text-xs font-semibold ${styles[kategori] || 'bg-gray-100 text-gray-800'}`}>
        {kategori}
      </span>
    );
  };

  const getPrioritasBadge = (prioritas) => {
    const colors = {
      low: 'text-gray-600',
      medium: 'text-yellow-600',
      high: 'text-orange-600',
      urgent: 'text-red-600'
    };

    return (
      <span className={`text-sm font-semibold ${colors[prioritas] || 'text-gray-600'}`}>
        {prioritas}
      </span>
    );
  };

  return (
    <div className="space-y-6">
      {/* Header */}
      <div className="flex items-center justify-between">
        <div>
          <h2 className="text-2xl font-bold text-gray-900">Tanya IT</h2>
          <p className="text-gray-600">Daftar tiket support dan komunikasi dengan tim IT</p>
        </div>
      </div>

      {/* Filters */}
      <div className="bg-white rounded-xl shadow-md p-6">
        <div className="flex flex-wrap gap-4 items-center">
          <div className="flex items-center gap-2">
            <Filter size={20} className="text-gray-500" />
            <span className="font-semibold text-gray-700">Filter:</span>
          </div>

          <select
            value={filterStatus}
            onChange={(e) => setFilterStatus(e.target.value)}
            className="px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary-500"
          >
            <option value="">Semua Status</option>
            <option value="open">Open</option>
            <option value="in_progress">Dalam Proses</option>
            <option value="resolved">Selesai</option>
            <option value="closed">Closed</option>
          </select>

          <select
            value={filterKategori}
            onChange={(e) => setFilterKategori(e.target.value)}
            className="px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary-500"
          >
            <option value="">Semua Kategori</option>
            <option value="masukan">Masukan</option>
            <option value="keluhan">Keluhan</option>
            <option value="rekomendasi">Rekomendasi</option>
            <option value="bug">Bug</option>
            <option value="error">Error</option>
          </select>

          <button
            onClick={() => setShowModal(true)}
            className="ml-auto px-6 py-2 bg-gradient-to-r from-primary-600 to-primary-700 text-white rounded-lg hover:from-primary-700 hover:to-primary-800 transition-all font-semibold flex items-center gap-2"
          >
            <Plus size={20} />
            Buat Tiket Baru
          </button>
        </div>
      </div>

      {/* Tiket List */}
      {loading ? (
        <div className="text-center py-12">
          <div className="inline-block animate-spin rounded-full h-12 w-12 border-b-2 border-primary-600"></div>
          <p className="mt-4 text-gray-600">Memuat tiket...</p>
        </div>
      ) : tikets.length === 0 ? (
        <div className="bg-white rounded-xl shadow-md p-12 text-center">
          <MessageSquare size={64} className="mx-auto text-gray-400 mb-4" />
          <h3 className="text-xl font-semibold text-gray-900 mb-2">Belum Ada Tiket</h3>
          <p className="text-gray-600 mb-6">
            Anda belum memiliki tiket support. Buat tiket baru untuk menghubungi tim IT.
          </p>
          <button
            onClick={() => setShowModal(true)}
            className="px-6 py-3 bg-gradient-to-r from-primary-600 to-primary-700 text-white rounded-lg hover:from-primary-700 hover:to-primary-800 transition-all font-semibold inline-flex items-center gap-2"
          >
            <Plus size={20} />
            Buat Tiket Pertama
          </button>
        </div>
      ) : (
        <div className="grid gap-4">
          {tikets.map((tiket) => (
            <div
              key={tiket.id}
              onClick={() => setSelectedTiket(tiket)}
              className="bg-white rounded-xl shadow-md p-6 hover:shadow-lg transition-shadow cursor-pointer border-l-4 border-primary-600"
            >
              <div className="flex items-start justify-between mb-4">
                <div className="flex-1">
                  <div className="flex items-center gap-3 mb-2">
                    {getStatusBadge(tiket.status)}
                    {getKategoriBadge(tiket.kategori)}
                    <span className="text-sm text-gray-500">
                      #{tiket.id.substring(0, 8)}
                    </span>
                  </div>
                  <h3 className="text-lg font-semibold text-gray-900 mb-1">
                    {tiket.subjek}
                  </h3>
                  <p className="text-gray-600 text-sm line-clamp-2">
                    {tiket.pesan}
                  </p>
                </div>
                <div className="text-right">
                  <div className="mb-2">
                    <div className="text-xs text-gray-500 mb-1">Prioritas</div>
                    {getPrioritasBadge(tiket.prioritas)}
                  </div>
                  <div className="text-xs text-gray-500">
                    {new Date(tiket.created_at).toLocaleDateString('id-ID', {
                      day: 'numeric',
                      month: 'short',
                      year: 'numeric',
                      hour: '2-digit',
                      minute: '2-digit'
                    })}
                  </div>
                </div>
              </div>

              {/* Balasan Preview */}
              {tiket.balasan && tiket.balasan.length > 0 && (
                <div className="border-t pt-4 mt-4">
                  <div className="flex items-center gap-2 text-sm text-gray-600">
                    <MessageSquare size={16} />
                    <span>{tiket.balasan.length} balasan</span>
                    <span className="text-gray-400">•</span>
                    <span>Terakhir: {new Date(tiket.balasan[tiket.balasan.length - 1].timestamp).toLocaleDateString('id-ID')}</span>
                  </div>
                </div>
              )}
            </div>
          ))}
        </div>
      )}

      {/* Tiket Detail Modal */}
      {selectedTiket && (
        <TiketDetailModal
          tiket={selectedTiket}
          onClose={() => setSelectedTiket(null)}
          onUpdate={fetchTikets}
        />
      )}

      {/* Create Modal */}
      {showModal && (
        <TanyaITModal
          isOpen={showModal}
          onClose={() => setShowModal(false)}
          onSubmit={fetchTikets}
        />
      )}
    </div>
  );
};

// Tiket Detail Modal Component
const TiketDetailModal = ({ tiket, onClose, onUpdate }) => {
  const [balasan, setBalasan] = useState('');
  const [loading, setLoading] = useState(false);

  const handleBalas = async () => {
    if (!balasan.trim()) return;

    setLoading(true);
    try {
      const token = localStorage.getItem('token');
      const formData = new FormData();
      formData.append('balasan', balasan);

      const response = await fetch(`${API_URL}/api/tiket-it/${tiket.id}/balas`, {
        method: 'PUT',
        headers: {
          'Authorization': `Bearer ${token}`
        },
        body: formData
      });

      if (response.ok) {
        setBalasan('');
        onUpdate();
      } else {
        alert('Gagal mengirim balasan');
      }
    } catch (err) {
      alert('Terjadi kesalahan');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-2xl shadow-2xl max-w-3xl w-full max-h-[90vh] overflow-hidden flex flex-col">
        {/* Header */}
        <div className="bg-gradient-to-r from-primary-600 to-primary-700 text-white p-6">
          <div className="flex items-center justify-between mb-4">
            <h3 className="text-xl font-bold">{tiket.subjek}</h3>
            <button onClick={onClose} className="p-2 hover:bg-white/20 rounded-full">
              <X size={24} />
            </button>
          </div>
          <div className="flex items-center gap-3 flex-wrap">
            <span className="px-3 py-1 rounded-full text-xs font-semibold bg-white/20">
              {tiket.kategori}
            </span>
            <span className="text-sm">{tiket.id.substring(0, 8)}</span>
            <span className="text-sm">
              {new Date(tiket.created_at).toLocaleString('id-ID')}
            </span>
          </div>
        </div>

        {/* Content */}
        <div className="flex-1 overflow-y-auto p-6">
          {/* Original Message */}
          <div className="mb-6">
            <div className="flex items-center gap-2 mb-2">
              <span className="font-semibold text-gray-900">
                {tiket.pengirim_role}
              </span>
              <span className="text-sm text-gray-500">• {new Date(tiket.created_at).toLocaleString('id-ID')}</span>
            </div>
            <div className="bg-gray-50 rounded-lg p-4">
              <p className="text-gray-800 whitespace-pre-wrap">{tiket.pesan}</p>
            </div>
          </div>

          {/* Balasan */}
          {tiket.balasan && tiket.balasan.length > 0 && (
            <div className="space-y-4 mb-6">
              {tiket.balasan.map((reply, idx) => (
                <div key={idx} className="flex items-start gap-3">
                  <div className={`flex-1 ${reply.pengirim === 'IT' ? 'bg-blue-50' : 'bg-gray-50'} rounded-lg p-4`}>
                    <div className="flex items-center gap-2 mb-2">
                      <span className="font-semibold text-gray-900">{reply.pengirim_nama || reply.pengirim}</span>
                      <span className="text-xs px-2 py-1 rounded-full bg-white text-gray-600">{reply.pengirim}</span>
                      <span className="text-sm text-gray-500">• {new Date(reply.timestamp).toLocaleString('id-ID')}</span>
                    </div>
                    <p className="text-gray-800 whitespace-pre-wrap">{reply.pesan}</p>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>

        {/* Reply Box */}
        <div className="border-t p-6">
          <textarea
            value={balasan}
            onChange={(e) => setBalasan(e.target.value)}
            placeholder="Tulis balasan..."
            rows={3}
            className="w-full px-4 py-3 border border-gray-300 rounded-lg resize-none"
          />
          <div className="flex justify-end mt-3">
            <button
              onClick={handleBalas}
              disabled={loading || !balasan.trim()}
              className="px-6 py-2 bg-primary-600 text-white rounded-lg hover:bg-primary-700 disabled:opacity-50 font-semibold"
            >
              {loading ? 'Mengirim...' : 'Kirim Balasan'}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TanyaITList;
